var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._v("Nueva Transferencia")])
}
var staticRenderFns = []

export { render, staticRenderFns }